import React from 'react';
import { RouterProvider } from 'react-router-dom';
import type { Router as RemixRouter } from '@remix-run/router';
import router from './app/router';
import { ThemeProviderWithMode } from './app/theme';
import { AuthProvider } from './contexts/AuthContext';
import { SnackbarProvider } from './contexts/SnackbarContext';
import './styles/index.css';

export type AppProps = { routerOverride?: RemixRouter };

export default function App({ routerOverride }: AppProps) {
  return (
    <ThemeProviderWithMode>
      <SnackbarProvider>
        <AuthProvider>
          <RouterProvider router={routerOverride ?? router} />
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProviderWithMode>
  );
}
